<template>
  <d-modal v-if="!!this.editMerchantID" size="lg">
    <d-modal-header :close="false">
      <d-modal-title>Edit Merchant</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div>
        <d-tabs>
          <d-tab title="Details" active>
            <div class="p-3">
              <div>
                <odd-label>Business Name</odd-label>
                <d-input v-model="businessName" class="mb-2" />

                <odd-label>Primary Contact</odd-label>
                <d-input v-model="primaryContact" class="mb-2" />

                <odd-label>Email Address</odd-label>
                <d-input v-model="email" class="mb-2" />
              </div>
            </div>
          </d-tab>
          <d-tab title="Locations">
            <div class="p-3">
              <d-list-group>
                <d-list-group-item v-for="loc in locations" :key="loc.id">
                  <div>{{ loc.name }}</div>
                  <div>{{ loc.address_line_1 }}</div>
                  <div>{{ loc.address_line_2 }}</div>
                  <div>
                    {{ loc.city }} {{ loc.state }}, {{ loc.postal_code }}
                  </div>
                </d-list-group-item>
              </d-list-group>
              <d-modal-body>
                <div>
                  <odd-label>Name</odd-label>
                  <d-input v-model="newLocationName" class="mb-2" />
                  <odd-label>Address Line 1</odd-label>
                  <d-input v-model="newLocationAdd1" class="mb-2" />
                  <odd-label>Address Line 2</odd-label>
                  <d-input v-model="newLocationAdd2" class="mb-2" />
                  <odd-label>City</odd-label>
                  <d-input v-model="newLocationCity" class="mb-2" />
                  <odd-label>State Initials</odd-label>
                  <d-input v-model="newLocationState" class="mb-2" />
                  <odd-label>Postal Code</odd-label>
                  <d-input v-model="newLocationPostal" class="mb-2" />
                </div>
                <div class="d-flex justify-content-end align-items-center pt-3">
                  <async-button
                    @click="insertLocation"
                    text="Add"
                    loadingText="saving..."
                    :loading="saving"
                  />
                </div>
              </d-modal-body>
            </div>
          </d-tab>
        </d-tabs>
      </div>
      <div class="d-flex justify-content-end align-items-center pt-3">
        <d-button class="mx-2" theme="light" @click="handleClose">
          Cancel
        </d-button>
        <async-button
          @click="updateMerchant"
          text="Save"
          loadingText="saving..."
          :loading="saving"
        />
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  data() {
    return {
      saving: false,
      merchant: null,
      businessName: "",
      primaryContact: "",
      email: "",
      locations: [],
      newLocationName: "",
      newLocationAdd1: "",
      newLocationAdd2: "",
      newLocationCity: "",
      newLocationState: "",
      newLocationPostal: ""
    };
  },
  props: {
    editMerchantID: {
      type: String,
      default: null
    }
  },
  computed: {
    showModal() {
      return this.editMerchantID !== null;
    }
  },
  watch: {
    showModal() {
      if (this.editMerchantID !== null) {
        this.$store
          .dispatch("merchants/get", this.editMerchantID)
          .then(result => {
            this.email = result.primary_contact_email;
            this.businessName = result.name;
            this.primaryContact = result.primary_contact;
          });
        this.loadLocations();
      } else {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm() {
      this.merchant = null;
    },
    handleClose(event) {
      this.$emit("close", event);
    },
    loadLocations() {
      return this.$store
        .dispatch("merchants/getLocations", this.editMerchantID)
        .then(result => {
          this.locations = result;
        });
    },
    insertLocation() {
      this.saving = true;
      const insertLocation = {
        merchantID: this.editMerchantID,
        location: {
          name: this.newLocationName,
          address_line_1: this.newLocationAdd1,
          address_line_2: this.newLocationAdd2,
          postal_code: this.newLocationPostal,
          city: this.newLocationCity,
          state: this.newLocationState
        }
      };
      this.$store
        .dispatch("merchants/insertLocation", insertLocation)
        .then(result => {
          this.loadLocations().then(data => {
            this.saving = false;
          });
        });
    },
    updateMerchant() {
      this.saving = true;
      const updateMerchant = {
        id: this.editMerchantID,
        primary_contact_email: this.email,
        name: this.businessName,
        primary_contact: this.primaryContact
      };

      this.$store.dispatch("merchants/update", updateMerchant).then(result => {
        this.saving = false;
        this.$emit("dataUpdated");
        this.handleClose();
      });
    }
  }
};
</script>

<style></style>
